import Typed from 'typed.js';

export default {
	init() {
    var typed = new Typed('#typedMessages', {
      strings: ["Backers", "Builders", "Guardians", "Allies", "Champions"],
      typeSpeed: 100,
      backSpeed: 0,
      loop: false,
      showCursor: false,
      backDelay: 1500,
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js